import { z } from "zod";

export enum FilterType {
  FILTER = "filter",
  COLUMN_PICKER = "column_picker",
  OPTIN_FEATURES = "optin_features",
}

export enum FilterApplicableFor {
  WAREHOUSE_QUERIES = "warehouse_queries",
  DBT_MODELS = "dbt_models",
  DBT_JOB_MODELS = "dbt_job_models",
  DBT_GOVERNANCE_CONFIGS = "dbt_governance_configs",
  AUTOTUNE_JOBS = "autotune_jobs",
  JOBS = "jobs",
  QUERY_GROUP = "query_group",
  GOVERNANCE_ROLES = "governance_roles",
  GOVERNANCE_USERS = "governance_users",
  WAREHOUSES = "warehouses",
  DATASET_LIST = "datasetslist",
  DATASETS = "datasets",
  QUERY = "query",
  DISCOVER = "discover",
  BI_REPORTS = "bi_reports",
  BI_REPORTS_USERS = "bi_reports_users",
  MCP_MEMORIES = "mcp_memories",
  TABLE_QUERIES = "table_queries",
  TAGS = "custom_tags",
  SUBSCRIPTIONS = "subscriptions",
  STORED_PROCEDURES = "stored_procedures",
  TASKS = "tasks",
  SNOWFLAKE_WORKLOADS = "snowflake_workloads",
  TABLEAU_WORKLOADS = "tableau_workloads",
  DBT_JOBS = "dbt_jobs",
  DBT_JOB_RUNS = "dbt_job_runs",
  AI_SERVICE_USAGE = "ai_service_usage",
  CHECKS = "checks",
  DATABRICKS_QUERIES = "databricks_queries",
  DATABRICKS_USERS = "databricks_users",
  DATABRICKS_JOB_RUNS = "databricks_job_runs",
  CLUSTERS = "clusters",
  SQL_WAREHOUSES = "sql_warehouses",
  AI_ML_ENDPOINTS = "ai_ml_endpoints",
}

export interface Filter {
  filterData?: Record<string, unknown>;
  filterStr: string | string[];
  label: string;
  onclose?: (removedFilter?: string) => void;
  searchKey?: string;
  bgColor?: string;
  condition?: string;
}

export const savedFilterSchema = z.object({
  name: z
    .string()
    .max(100, { message: "Name must not exceed 100 characters" })
    .min(1, { message: "Name is required" }),
  data: z.record(z.string(), z.unknown()).refine(data => Object.keys(data).length > 0, {
    message: "At least one filter must be selected",
  }),
  applicable_for: z.enum(Object.values(FilterApplicableFor) as [string, ...string[]]),
  type: z.enum(Object.values(FilterType) as [string, ...string[]]),
});

export type SavedFilter = z.infer<typeof savedFilterSchema> & { id: string };

export type FilterValue = { values: string | string[]; condition: string };

// Schema for preset/filter API responses
export const PresetIdResponseSchema = z.object({
  preset_id: z.number(),
});
